import { callApi } from './ApiClient';

const getOrderContacts = (dispatch) => {
  return callApi('GET', '/order_contacts', null, dispatch);
}

const postOrderContacts = (data, dispatch) => {
  return callApi('POST', '/order_contacts', data, dispatch);
}

const deleteOrderContacts = (id, dispatch) => {
  return callApi('DELETE', `/order_contacts/${id}`, null, dispatch);
}

export const OrderContactApi = {
  getOrderContacts,
  postOrderContacts,
  deleteOrderContacts,
};



// WEBPACK FOOTER //
// ./src/redux/api/OrderContactApi.js